import React from "react";
import css from "classnames";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import { Tooltip } from "@mui/material";
import { green } from "@mui/material/colors";
import { SelectAutocomplete } from "components/haven-design/form/select";
import { CATEGORIES } from "../constants";
import { Actions, Document, HTTPStatus, ActionTypes } from "../reducer";
import styles from "./index.module.css";


type DocumentRowType = {
  key: React.Key | null | undefined;
  document: Document;
  dispatch: React.Dispatch<ActionTypes>;
};

const optionToCategory = (option: string | null) =>
  CATEGORIES.find((category) => category.name === option);

const DocumentCategory: React.FC<Omit<DocumentRowType, "key">> = ({ document, dispatch }) => (
  <SelectAutocomplete
    style={{ minWidth: "15em" }}
    margin="dense"
    label="Select a Category"
    disableClearable
    disabled={document.httpStatus !== null}
    options={CATEGORIES}
    getOptionLabel={(option) => option.name}
    groupBy={({ group }) => group}
    value={optionToCategory(document.category)}
    error={document.validation !== null}
    helperText={document.validation || ""}
    onChange={(_, value) => {
      if (value) {
        dispatch({
          type: Actions.ChangeFileCategory,
          payload: { id: document.id, category: value.name },
        });
      }
    }}
  />
);

const DocumentName: React.FC<{document: Document }> = ({ document }) => (
  <span
    className={css(styles.detail, styles.filename)}
    title={document.file.name}
  >
    {document.file.name}
  </span>);

const DocumentRow: React.FC<DocumentRowType> = ({ document, dispatch }) => (
  <tr
    key={document.id}
    className={css({
      success: document.httpStatus === HTTPStatus.Success,
      danger: document.httpStatus === HTTPStatus.Error,
      [styles.shimmer]: document.httpStatus === HTTPStatus.Loading,
    })}
  >
    <td>
      {document.httpStatus === HTTPStatus.Success ? (<Tooltip title="Uploaded">
        <CloudDoneIcon style={{ color: green[500] }} />
      </Tooltip>) : (<Tooltip title="Pending">
        <CloudUploadIcon />
      </Tooltip>
      )}
    </td>
    <td>
      <DocumentName document={document} /></td>
    <td>
      <DocumentCategory document={document} dispatch={dispatch} />
    </td>
    <td>
      <span className={styles.detail}>
        {(document.file.size / 1000 / 1000).toFixed(2)}MB
      </span>
    </td>
    <td>
      {document.httpStatus === null && (
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={() => {
            dispatch({
              type: Actions.RemoveFile,
              payload: { id: document.id },
            });
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </td>
  </tr>);

export default DocumentRow;
